import { useMemo } from 'react';
import useProjectData from '@hooks/useProjectData';
import { useProjectDashboardFilters } from '@store/zustand/project-dashboard-filters';

const useDashboardPartners = () => {
  const [{ partners: projectPartners }] = useProjectData();
  const { partners } = useProjectDashboardFilters();

  return useMemo(() => {
    const options = projectPartners ?? [];

    return {
      options,
      selected: options.filter((partner) => partners.includes(partner)),
    };
  }, [projectPartners, partners]);
};

export default useDashboardPartners;
